import { EUserType } from "services/BackendApi";

let email: string | null = null;
let country: string | null = null;
let userType: EUserType | null = null;

export const setTrackingContext = (ctx: {
  email: string;
  country?: string | null;
  userType: EUserType;
}): void => {
  email = ctx.email || null;
  if (ctx.country !== undefined) country = ctx.country || null;
  userType = ctx.userType || null;
};

export const clearTrackingContext = (): void => {
  email = null;
  country = null;
  userType = null;
};

export const getTrackingContext = (): {
  email: string | null;
  country: string | null;
  userType: EUserType | null;
} => ({
  email,
  country,
  userType,
});

export const hasTrackingIdentity = (): boolean => Boolean(email);
